"use client";

import { useSpineSlice } from "@/components/site/motion/useSpineSlice";
import { ContactForm } from "@/components/sections/contact/ContactForm";

export function Contact() {
  useSpineSlice((m) => m.spine!.buildContact());

  return (
    <div className="landing_content contact_content f a-c j-c" id="contact">
      <ContactForm />
    </div>
  );
}
